// test2770
(2770 && 0);
